import { render, staticRenderFns } from "./Tarifada.vue?vue&type=template&id=2f3bf34e&scoped=true"
import script from "./Tarifada.vue?vue&type=script&lang=js"
export * from "./Tarifada.vue?vue&type=script&lang=js"
import style0 from "./Tarifada.vue?vue&type=style&index=0&id=2f3bf34e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3bf34e",
  null
  
)

export default component.exports